<div id="getRFParamSetElements" class="table-header margin-top-30">
  <span>RF ParamSet</span>
  <div class="table-icon refresh"
       (click)="refreshRfParamSetElements()">
    <i class="text-tooltip"
       [ngClass]="(paramSetsRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
       aria-hidden="true"
       title-popup="Refresh">
    </i>
  </div>
  <div *ngIf="isAdmin" class="table-icon plus">
    <i class="fa fa-plus transition text-tooltip"
       (click)=addRfParamSetPage(name,virtId,createRP)
       aria-hidden="true"
       title-popup="Add"></i>
  </div>
</div>
<div class="table-panel">
  <table class="table-roaming-partners table table-striped table-responsive"
           id="rfParamSet-elements-list">
    <thead>
      <tr>
        <th>ID</th>
        <th>Timestamp</th>
        <th>RFParamSet</th>
        <th *ngIf="isAdmin"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of listRfParamSetElements | paginate: configPageRfParamSetElements">
        <td>{{item.RFParamSetID}}</td>
        <td>{{item.RFParamSetTimestamp}}</td>
        <td>{{item.ActilityRFParamSet}}</td>
        <td *ngIf="isAdmin">
          <ng-template #actionsPopup>
            <p class="popup-text" (click)="deleteModal.show()">Delete</p>
          </ng-template>
          <button class="view-detail-btn"
                  [popover]="actionsPopup"
                  placement="left"
                  triggers="click"
                  [outsideClick]="true"
                  container="body">...</button>
            <app-delete-modal #deleteModal
                              text="RF ParamSet Element {{item.RFParamSetID}} will be deleted."
                              nsId="{{virtId}}"
                              rfParamSetId="{{item.RFParamSetID}}"
                              deleteType="rfParamSetElement"></app-delete-modal>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="noDataRow"
       *ngIf="!listRfParamSetElements || listRfParamSetElements.length === 0">There is no data available
  </div>
</div>
